import * as THREE from 'three'
import Experience from '../Experience'
let elapsedTime = 0

export default class Loader {
  constructor() {
    this.loader = document.querySelector('.loader')
    this.loadingBar = document.querySelector('.progressBar')
    this.loadingBar.style.width = elapsedTime + 'px'
    this.experience = new Experience()
    this.clock = new THREE.Clock()
  }
  update() {
    this.clockTime = this.clock.getElapsedTime()
    elapsedTime = this.clockTime * 25
    this.loadingBar.style.width = elapsedTime + 'px'
  }
}
